import { render, staticRenderFns } from "./remitoMonitoring.vue?vue&type=template&id=227f2ade&"
import script from "./remitoMonitoring.vue?vue&type=script&lang=js&"
export * from "./remitoMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VInput,VTooltip})
